import type { StateCreator } from 'zustand'

import { PERMISSION_MODULE } from '~/core/constants/enum'

export interface ITenantPermissionSettingType {
  /**
   * Id permission trên BE (có thể dùng khi mapping/patch permission).
   */
  id?: number
  visibility: boolean
  moduleName: string
  kind: string
  toggleable: boolean
  enabled: boolean
  /**
   * Mapping cấu trúc objectMapping theo BE (dùng cho các logic permission nâng cao).
   */
  objectMapping?: any
  /**
   * Field-level permissions for profile_management (systemFields + customFields from BE).
   */
  profileFields?: any
  /**
   * Field permission summary counts from userPermissionsList (e.g. profile / applicant).
   */
  fieldPermissionsStats?: Record<
    string,
    {
      totalFields?: number
      totalAccessFields?: number
    }
  >
  objects: Array<{
    name: string
    enabled: boolean
    actions: Array<string>
    permissions: Array<string>
    visibility?: boolean
  }>
}

export interface TenantPermissionSettingSlice {
  permissionSetting: ITenantPermissionSettingType[]
  setPermissionSetting: (permissionSetting: ITenantPermissionSettingType[]) => void
  reportPermission: ITenantPermissionSettingType | undefined
}

export const createTenantPermissionSettingSlice: StateCreator<
  TenantPermissionSettingSlice,
  [],
  [],
  TenantPermissionSettingSlice
> = (set: Function) => ({
  permissionSetting: [],
  reportPermission: undefined,
  setPermissionSetting: (permissionSetting: ITenantPermissionSettingType[]) =>
    set({
      permissionSetting,
      reportPermission: permissionSetting.find((fi) =>
        [PERMISSION_MODULE.report].includes(fi.moduleName)
      )
    })
})
